import { Params } from '@angular/router';

import { Status } from '../business/kenobi/status.enum';

export class TrackingUtils {
    /**
     * Returns the src queryParam value if present (query param name is case insensitive)
     * @param {Params} params
     * @returns {string} URI encoded value, `undefined` when absent
     */
    public static getSrcQueryParam(params: Params): string | undefined {
        const srcParamName = Object.keys(params).find((key) => /^src$/i.test(key));

        if (srcParamName && params[srcParamName]) {
            return encodeURI(params[srcParamName]);
        }

        return undefined;
    }

    /**
     * Gets Kenobi status from HTTP status
     * @param {number} httpStatus Technical HTTP status
     * @returns {Status}
     */
    public getKenobiStatusFromHttpStatus(httpStatus: number) {
        const httpStatusString: string = httpStatus.toString();
        let kenobiStatus: Status;

        if (httpStatusString.startsWith('4')) {
            kenobiStatus = Status.KORG;
        } else if (httpStatusString.startsWith('5')) {
            kenobiStatus = Status.KOSI;
        } else {
            kenobiStatus = Status.OK;
        }

        return kenobiStatus;
    }
}
